import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { instance } from '../helper'
import { useTranslation } from 'react-i18next'

const CallbackPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('soockerEntry')

  useEffect(() => {
    const queryString = window.location.search
    instance({
      method: 'GET',
      url: `/soocker/login${queryString}`
    })
      .then((res) => {
        window.localStorage.setItem('accessToken', res.data.access_token)
        window.location.href = '/'
      })
      .catch(() => navigate('/error'))
  }, [])

  return (
    <div>
      <h2>{t('logging')}</h2>
    </div>
  )
}

export default CallbackPage
